import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isCheckoutModalOpen, setCheckoutModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Open checkout modal
  const openCheckout = (product) => {
    setSelectedProduct(product);
    setCheckoutModalOpen(true);
  };

  // Close checkout modal
  const closeCheckout = () => {
    setCheckoutModalOpen(false);
    setSelectedProduct(null);
  };

  const value = {
    isCheckoutModalOpen,
    setCheckoutModalOpen,
    selectedProduct,
    openCheckout,
    closeCheckout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
